import type {MilestonePickerMilestone} from '@github-ui/item-picker-milestone'
import {type Dispatch, type SetStateAction, useState} from 'react'

/**
 * Local active-milestone state that clears to `null` when the upstream
 * `currentMilestoneTokens` array transitions to empty. Returns the cleared value
 * in the same render so consumers (e.g. `<MilestonePicker activeMilestone>`) see
 * the reset without an extra commit.
 */
export function useActiveMilestone(
  currentMilestoneTokens: readonly unknown[],
): [MilestonePickerMilestone | null, Dispatch<SetStateAction<MilestonePickerMilestone | null>>] {
  const [activeMilestone, setActiveMilestone] = useState<MilestonePickerMilestone | null>(null)
  const [prevCurrentMilestoneTokens, setPrevCurrentMilestoneTokens] = useState(currentMilestoneTokens)
  if (currentMilestoneTokens !== prevCurrentMilestoneTokens) {
    setPrevCurrentMilestoneTokens(currentMilestoneTokens)
    if (currentMilestoneTokens.length <= 0 && activeMilestone !== null) {
      setActiveMilestone(null)
      return [null, setActiveMilestone]
    }
  }
  return [activeMilestone, setActiveMilestone]
}
